import { IAccount } from './iAccount';

export interface IInteractionItem {
    id: string;
    title?: string;
    icon?: string;
    subject?: string;
    source?: string;
    message: string;
    creation_time: string;
    created_by: IAccount;
    incomingFiles: [];
    related_model: string;
    sg_action_type?: string;
    call_date?: string;
    dnis?: string;
    ani?: string;
    relatedModel?: string;
    attachments?: any;
    skill_group_id?: any;
    folder_id?: any;
    to?: any;
    cc?: any;
}

export enum MessageTypes {
    'TELEPHONE' = 'Telephone_Model_History',
    'SMS' = 'Sms_Model_Message',
    'EMAIL' = 'Email_Model_Message',
    'DIRECT' = 'DirectMessaging_Model_Message'
}

export function GenerateInteractionItemGuid(length) {
  const s = '0123456789abcdef';
  const uuid = new Array(length);

  for(let i=0; i<length; i++) {
    uuid[i] = s.charAt(Math.ceil(Math.random() *15));
  }
  return uuid.join('');
}

